// Copyright (c) 2026 SoundDrift. All rights reserved.

// Build version injected by Vite `define` (see vite.config.js).
export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
